module.exports = __webpack_public_path__ + "img/22.2943b50e.png";